import * as React from 'react';
import { I18nManager } from 'react-native';
import DefaultTheme from '../styles/DefaultTheme';
import { ThemeProvider } from './theming';

const Provider = _ref => {
  let {
    children,
    theme
  } = _ref;
  const themeToUse = theme || DefaultTheme;
  const rtlTheme = { ...themeToUse,
    isRTL: themeToUse.isRTL || I18nManager.isRTL
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: rtlTheme
  }, children);
};

export default Provider;
//# sourceMappingURL=Provider.js.map